export default "__VITE_ASSET__CgwVOqLu__"